import { isApiRequestError } from '@/errors/ApiRequestError'

/**
 * A refusal is an answer; only a transport failure is worth asking again.
 *
 * Without this a route the server does not have, or a token it will not accept, keeps a screen
 * on its loading state for twenty seconds before admitting the truth.
 */
export const retryUnlessRefused = (failureCount: number, error: unknown) => {
	const status = isApiRequestError(error) ? error.status : undefined
	if (status !== undefined && status >= 400 && status < 500) {
		return false
	}
	return failureCount < 2
}
